import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
// import { DialogService } from 'ng2-bootstrap-modal';
import { labels } from './../../service/sector.model';
import { ManageService } from './../../service/manage.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.css']
})
export class LogComponent implements OnInit {
  loglist = [];

  constructor(private getlabels: DBConnectorService,
    private manage: ManageService,
    // private dialogService: DialogService,
    private loggedInGuard: LoggedInGuard) {
  }

  getloglist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.manage.getLogDetail()
        //.subscribe(res => this.loglist = res)
        .subscribe(
          (data) => {
            this.loglist = data;
            console.log(this.loglist);
            // console.log(this.result);
            // this.getsectorlist();
          });
    }
  }

  ngOnInit() {
    this.getloglist();
  }
}
